import { List } from 'immutable';

import { createAppSelector } from 'app-components/utils/core/reselect';
import type RootState from 'app-components/utils/redux-store/rootState';

import { INSTITUTIONS_REDUCER_KEY, type Institution } from './institutionsTypes';

type State = Pick<RootState, typeof INSTITUTIONS_REDUCER_KEY>;

export const getInstitutionStore = (state: State) => state[INSTITUTIONS_REDUCER_KEY];
export const getInstitutionsById = (state: State) => getInstitutionStore(state).resourcesById;
export const getPopularInstitutionIds = (state: State) => getInstitutionStore(state).popularIds;

export const getResourcesById = (state: State) => getInstitutionStore(state).resourcesById;
export const getLoadPending = (state: State) => getInstitutionStore(state).loadPending;
export const getIsLoading = (state: State) => getInstitutionStore(state).isLoading;
export const getError = (state: State) => getInstitutionStore(state).error;

export const getInstitution = (state: State, id: string) => {
  const institutionsById = getInstitutionsById(state);
  return institutionsById.get(id);
};

export const getPopularInstitutions = createAppSelector(
  getInstitutionsById,
  getPopularInstitutionIds,
  (institutionsById, popularIds) => {
    if (!popularIds) {
      return null;
    }
    const popularInstitutions = popularIds.reduce<Institution[]>((list, id) => {
      const institution = institutionsById.get(id);
      if (institution) {
        list.push(institution);
      }
      return list;
    }, []);
    if (popularInstitutions.length === 0) {
      return null;
    }
    return List(popularInstitutions);
  },
);
